module.exports = __webpack_public_path__ + "static/img/006.4d24b986.png";